'use client';

import WithMediaQuery from 'app/components/common/WithMediaQuery';
import ScheduleFilter, {
  IScheduleFilterFormFields
} from 'app/components/common/schedule/ScheduleFilter';

export default function ScheduleFilterDesktopRender({
  initialState
}: {
  initialState: IScheduleFilterFormFields;
}) {
  return (
    <WithMediaQuery>
      {({ isScreen_md }) =>
        isScreen_md && <ScheduleFilter initialState={initialState} />
      }
    </WithMediaQuery>
  );
}
